<div class="edit-profil-page">
  <header class="edit-header">
    <button type="button" class="back-button" (click)="goBack()" aria-label="Retour">
      <span>‹</span>
    </button>
    <h1 class="header-title">Modifier mon profil</h1>
    <div class="header-spacer" aria-hidden="true"></div>
  </header>
  <div class="edit-content">
    <app-edit-profil></app-edit-profil>
  </div>
  <app-navbar></app-navbar>
</div>
